import { useState, useEffect } from "react";
import ActivatedModal from "../components/ActivatedModal";
import HelpButton from "../components/shared/HelpButton";
import { cssUrl } from "../utils/cssVersion";

const personalStyles = cssUrl("newuseronboarding.css");

/* ============================================================================
 * StaffActivation
 * ----------------------------------------------------------------------------
 * A standalone home for the Activated modal — the same header card as
 * SubcontractorComplete, with just the help button and the Activated icon.
 * ==========================================================================*/

// User with a check badge — "Activated"
const UserCheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="8.5" cy="7" r="4" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 11l2 2 4-4" />
  </svg>
);

const IconButton = ({ onClick, title, icon }) => (
  <button
    onClick={onClick}
    title={title}
    aria-label={title}
    style={{
      width: "32px",
      height: "32px",
      borderRadius: "8px",
      border: "1px solid rgba(34, 211, 238, 0.25)",
      background: "rgba(34, 211, 238, 0.08)",
      color: "#22d3ee",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 0,
      flexShrink: 0,
    }}
  >
    {icon}
  </button>
);

const StaffActivation = () => {
  const [activatedOpen, setActivatedOpen] = useState(false);

  /* ---------- stylesheet ---------- */
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = personalStyles;
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <div className="ob-container" style={{ width: "100%", maxWidth: "100%" }}>
      {activatedOpen && <ActivatedModal onClose={() => setActivatedOpen(false)} />}

      <div
        className="ob-form-card"
        style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box", maxHeight: "none" }}
      >
        <div className="ob-record-card">
          <div className="ob-record-header">
            <div className="ob-record-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M12.5 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM17 11l2 2 4-4"
                />
              </svg>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <h3 className="ob-record-title" style={{ margin: 0 }}>
                Staff Activation
              </h3>
              <HelpButton
                helpData={[
                  { chip: "staffactivation", urlFilter: "/static/pdffilters/StaffActivation.pdf" },
                ]}
              />
              <IconButton
                onClick={() => setActivatedOpen(true)}
                title="Activated"
                icon={<UserCheckIcon />}
              />
            </div>
          </div>
          <p className="ob-helper" style={{ marginTop: "8px" }}>
            Open Activated to see Casuals, Employees, Contractors and New Users, check who is
            not yet set up in the login system, tick the ones ready and email the report.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StaffActivation;